import React from "react";
import { AcademicCapIcon } from "@heroicons/react/solid";
import { certificate } from "../data";

// Shares the token system used in Projects.jsx and Skills.jsx
// bg #0B0D12   surface #12151B   border #232733
// text #EDEFF3   muted #8D93A3   accent-1 #9C8CFF (violet)

export default function Testimonials() {
  return (
    <section id="testimonials" className="bg-[#0B0D12] text-[#8D93A3]">
      <div className="container mx-auto px-6 py-24 lg:px-8 max-w-6xl text-center">
        <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 rounded-md border border-[#232733] bg-[#12151B]">
          <span className="w-2 h-2 rounded-full bg-[#9C8CFF]" />
          <span className="font-mono text-xs tracking-wide text-[#8D93A3]">
            certifications.json
          </span>
        </div>

        <AcademicCapIcon className="w-8 h-8 mx-auto mb-4 text-[#8D93A3]" />
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#EDEFF3] mb-14">
          Certifications
          <span className="inline-block w-[10px] h-[1.9rem] bg-[#9C8CFF] ml-2 align-middle animate-[blink_1.1s_steps(1)_infinite]" />
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6 text-left">
          {certificate.map((cert, index) => (
            <div
              key={cert.title ?? index}
              className="group rounded-xl border border-[#232733] bg-[#12151B] p-3 transition-colors duration-300 hover:border-[#9C8CFF]/50"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-[#0B0D12]">
                <img
                  src={cert.img}
                  alt={cert.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>

              {cert.issuer && (
                <p className="font-mono text-[11px] tracking-wide text-[#9C8CFF] mt-4 mb-1">
                  {cert.issuer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes blink { 50% { opacity: 0; } }
      `}</style>
    </section>
  );
}